import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Delegates, UserRole, UserType } from "enums/account";

interface ProtectedRouteProps {
  target: string;
  children: React.ReactNode;
  restrictTeamUsers?: boolean;
  restrictIndividual?: boolean;
  requiredRole?: UserRole[];
  requiredPrivilege?: Delegates | Delegates[];
}

const ProtectedRoute = ({
  target,
  children,
  restrictTeamUsers = false,
  restrictIndividual = false,
  requiredRole,
  requiredPrivilege,
}: ProtectedRouteProps) => {
  const app = useSelector((state: any) => state.app?.allData || {});
  const selectedEntity = app.entities_info?.find(
    (entity: any) => entity.id === app.entityId
  );

  // Check if selectedEntity exists
  if (!selectedEntity) {
    return <Navigate to={`/?target=${target}`} replace />;
  }

  const isTeamUser =
    selectedEntity.account_type === UserType.TEAM &&
    selectedEntity.role === UserRole.USER;
  const userRole = selectedEntity.role as UserRole;
  const isIndividual = selectedEntity.account_type === "Individual";
  const userPrivileges = selectedEntity.privileges || [];

  if (!app.token) {
    return <Navigate to={`/?target=${target}`} replace />;
  }

  // Check role first
  if (requiredRole && !requiredRole.includes(userRole)) {
    return <Navigate to="/entities" replace />;
  }

  // Check privileges ONLY if user is MODERATOR (role = 4)
  if (
    userRole === UserRole.MODERATOR &&
    requiredPrivilege &&
    !userPrivileges.includes(requiredPrivilege)
  ) {
    return <Navigate to="/entities" replace />;
  }

  if (isIndividual && restrictIndividual) {
    return <Navigate to="/entities" replace />;
  }

  if (isTeamUser && restrictTeamUsers) {
    return <Navigate to="/entities" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
